import { render } from "./VendorInfo.vue?vue&type=template&id=37a7947c&scoped=true"
import script from "./VendorInfo.vue?vue&type=script&lang=js"
export * from "./VendorInfo.vue?vue&type=script&lang=js"

import "./VendorInfo.vue?vue&type=style&index=0&id=37a7947c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a7947c"]])

export default __exports__